export default __webpack_public_path__ + "static/media/giphy.7f0dae04.png";